// export const searchRegionChoicesReducer = () => {
//   return [
//     {
//       label: 'US Prod',
//       value: 'us-prod',
//     },
//     {
//       label: 'US Dev',
//       value: 'us-dev',
//     },
//     {
//       label: 'AU Prod',
//       value: 'au-prod',
//     },
//     {
//       label: 'EU Prod',
//       value: 'eu-prod',
//     },
//     {
//       label: 'Local Host',
//       value: 'localhost',
//     },
//   ];
// }

export default function region(state= "us-dev", action: { type: string, payload: string }) {
  switch (action.type) {
    case "SEARCH_REGION":
      return action.payload;
    default:
      return state;
  }
}